import { render, staticRenderFns } from "./ScrollHintArrowsVert.vue?vue&type=template&id=2d864dd1&scoped=true"
import script from "./ScrollHintArrowsVert.vue?vue&type=script&lang=ts"
export * from "./ScrollHintArrowsVert.vue?vue&type=script&lang=ts"
import style0 from "./ScrollHintArrowsVert.vue?vue&type=style&index=0&id=2d864dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d864dd1",
  null
  
)

export default component.exports